import React from 'react';
import { motion, Variants } from 'framer-motion';

interface StaggerGroupProps {
  children: React.ReactNode;
  className?: string;
  staggerDelay?: number;
  once?: boolean;
}

const groupVariants: Variants = {
  hidden: {},
  visible: (staggerDelay: number) => ({
    transition: { staggerChildren: staggerDelay },
  }),
};

/**
 * Wrap a grid/list with StaggerGroup and each item with StaggerItem to get a
 * consistent "cards cascade in one after another" reveal (event grids,
 * feature lists, ticket tiers) - the paired primitive to Reveal, for
 * collections instead of single blocks.
 */
export const StaggerGroup: React.FC<StaggerGroupProps> = ({
  children,
  className = '',
  staggerDelay = 0.08,
  once = true,
}) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="visible"
    viewport={{ once, amount: 0.15 }}
    variants={groupVariants}
    custom={staggerDelay}
  >
    {children}
  </motion.div>
);

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] } },
};

export const StaggerItem: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = '',
}) => (
  <motion.div className={className} variants={itemVariants}>
    {children}
  </motion.div>
);
